@if ({ isLoading: loadingService.isSpinnerActive$('loadAdConnection') | async }; as loadingState) { @if (!loadingState.isLoading) {
<coso-replicator-page-header [title]="title"></coso-replicator-page-header>
@if (isRunning) {
<alert type="warning">
  <coso-alert-message>You can only modify the content of this page once the replication process is stopped.</coso-alert-message>
</alert>
} @if (errorMessage) {
<alert type="danger" [dismissible]="true" (onClose)="errorMessage = undefined">
  <coso-alert-message>
    <div class="d-inline" [innerHTML]="errorMessage"></div>
  </coso-alert-message>
</alert>
}
<form [formGroup]="formGroup" (ngSubmit)="saveConnection()">
  <div class="card card-cns mb-3">
    <div class="card-header">Active Directory</div>
    <div class="card-body">
      <p class="text-muted">
        <small><em>All fields are required unless specified optional</em></small>
      </p>
      @if ({ isTestingConnection: isTestingConnection$ | async, testConnectionResult: testConnectionResult$ | async }; as testConnectionMetadata) {
      <coso-text-input type="text" [control]="formGroup.controls.server" [inputText]="formText.server" [readonly]="isReadOnly"></coso-text-input>
      <coso-text-input type="text" [control]="formGroup.controls.username" [inputText]="formText.username" [readonly]="isReadOnly"></coso-text-input>
      <coso-text-input type="password" [control]="formGroup.controls.password" [inputText]="formText.password" [readonly]="isReadOnly"></coso-text-input>
      <coso-text-input type="text" [control]="formGroup.controls.organizationalUnitName" [inputText]="formText.organizationalUnitName" [readonly]="isReadOnly"></coso-text-input>
      <div class="form-group row align-items-center">
        <div class="offset-lg-2 col-lg-3">
          <button type="button" class="btn btn-primary btn-block" (click)="testConnection()" [disabled]="testConnectionMetadata.isTestingConnection">
            Test connection @if (testConnectionMetadata.isTestingConnection) {
            <span class="fa fa-spinner fa-spin ml-1" aria-live="polite" aria-busy="true" aria-hidden="true"></span>
            }
          </button>
        </div>
      </div>
      @if (testConnectionMetadata.testConnectionResult) {
      <div class="form-group row">
        <div class="offset-lg-2 col-lg-10">
          <alert [type]="testConnectionMetadata.testConnectionResult.isSuccess ? 'success' : 'danger'" [dismissible]="true">
            <coso-alert-message>{{ testConnectionMetadata.testConnectionResult.message }}</coso-alert-message>
          </alert>
        </div>
      </div>
      } }
    </div>
  </div>
  <div class="form-group row">
    <div class="col-lg-12">
      <div class="d-flex justify-content-between">
        <a class="btn btn-dark" [routerLink]="['/', 'configuration', instanceId, 'connections']"><span class="fa fa-chevron-left mr-1" aria-hidden="true"></span>Back to Connections list</a>
        @if (!isReadOnly) {
        <button type="submit" class="btn btn-primary col-2" [disabled]="formGroup.invalid">Save</button>
        }
      </div>
    </div>
  </div>
</form>
} }

<ng-template #serverPopover>
  <p>The URL to configure the connection to the directory server (LDAP connection URL).</p>
  Examples:
  <ul>
    <li>DomainController</li>
    <li>10.23.90.130</li>
    <li>hostname</li>
  </ul>
</ng-template>

<ng-template #organizationalUnitPopover>
  The name of the organizational unit in Dynamics 365, in which groups will be maintained. If empty, an organizational unit will be created in your Active Directory (called
  <i>CbReplicator</i>).
</ng-template>
